import {Record} from 'immutable';
import moment from 'moment';

const record = Record({
  id: null,
  jobStatusTopic: null,
  status: null,
  custom: false,
  link: null,
  token: '',
  typeface: null,
  workingSet: null,
  family: '',
  cssClass: '',
  weight: '',
  style: '',
  subsetting: '',
  characterSets: [],
  originalSize: 0,
  optimizedSize: 0,
  woff: '',
  createdAt: null,
  updatedAt: null,
});

class WorkingSetTypeface extends record {
  get createdAt() {
    return moment(super.createdAt);
  }

  get updatedAt() {
    return moment(super.updatedAt);
  }
}

export default WorkingSetTypeface;



// WEBPACK FOOTER //
// ./app/javascript/records/WorkingSetTypeface.js